export enum ItinerarySegmentPlaceholderType {
  None = 'None',
  Flight = 'Flight',
  Ferry = 'Ferry',
  Car = 'Car',
  Walk = 'Walk',
  Bicycle = 'Bicycle',
  Accommodation = 'Accommodation',
  Activity = 'Activity',
}
